// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".components-form-textareastyleAnimation-shakeHorizontal-eofmt{animation:components-form-textareastyleAnimation-shake-horizontal-udsvr .4s cubic-bezier(.455,.03,.515,.955) both}@keyframes components-form-textareastyleAnimation-shake-horizontal-udsvr{0%,to{transform:translateX(0)}10%,30%,50%,70%{transform:translateX(-10px)}20%,40%,60%{transform:translateX(10px)}80%{transform:translateX(8px)}90%{transform:translateX(-8px)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"shakeHorizontal": "components-form-textareastyleAnimation-shakeHorizontal-eofmt",
	"shake-horizontal": "components-form-textareastyleAnimation-shake-horizontal-udsvr"
};
module.exports = ___CSS_LOADER_EXPORT___;
